import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService, ButtonLoader } from '../../../../../core';
import { ClienteAnaliseFinanceiraAuthGuardService, ClienteAnaliseFinanceiraIniciarHttpService, ClienteAnaliseFinanceiraConcluirHttpService } from '../services';
import { ClienteNomePipe } from '../../pipes/cliente-nome.pipe';
import { ClienteAnaliseFinanceira } from '../cliente-analise-financeira';

interface Config {
    canIniciar: boolean;
    canCancelarIniciar: boolean;
    canConcluir: boolean;
    canCancelarConcluir: boolean;
    canRevisar: boolean;
}

@Component({
    selector: 'sgt-cliente-analise-financeira-btn-options',
    templateUrl: './cliente-analise-financeira-btn-options.component.html',
    styleUrls: ['./cliente-analise-financeira-btn-options.component.less']
})
export class ClienteAnaliseFinanceiraBtnOptionsComponent implements OnChanges {
    config: Config;

    @Input() idCliente: number;
    @Input() status: number;

    // Iniciar
    @ViewChild('dropdownItemIniciar') dropdownItemIniciar: ElementRef;
    @Output() afterIniciar = new EventEmitter<ClienteAnaliseFinanceira>();
    // Cancelar Iniciar
    @ViewChild('dropdownItemCancelarIniciar') dropdownItemCancelarIniciar: ElementRef;
    @Output() afterCancelarIniciar = new EventEmitter<ClienteAnaliseFinanceira>();
    // Concluir
    @Output() concluir = new EventEmitter<void>();
    // Cancelar Concluir
    @ViewChild('dropdownItemCancelarConcluir') dropdownItemCancelarConcluir: ElementRef;
    @Output() afterCancelarConcluir = new EventEmitter<ClienteAnaliseFinanceira>();
    // Revisar
    @Output() revisar = new EventEmitter<void>();

    constructor(private messageService: MessageService,
                private clienteNomePipe: ClienteNomePipe,
                private clienteAnaliseFinanceiraAuthGuardService: ClienteAnaliseFinanceiraAuthGuardService,
                private clienteAnaliseFinanceiraIniciarHttpService: ClienteAnaliseFinanceiraIniciarHttpService,
                private clienteAnaliseFinanceiraConcluirHttpService: ClienteAnaliseFinanceiraConcluirHttpService) { }


    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'status') {
                this.setConfig();
            }
        }
    }

    private setConfig() {
        this.config = {
            canIniciar: this.clienteAnaliseFinanceiraAuthGuardService.canIniciar(this.status),
            canCancelarIniciar: this.clienteAnaliseFinanceiraAuthGuardService.canCancelarIniciar(this.status),
            canConcluir: this.clienteAnaliseFinanceiraAuthGuardService.canConcluir(this.status),
            canCancelarConcluir: this.clienteAnaliseFinanceiraAuthGuardService.canCancelarConcluir(this.status),
            canRevisar: this.clienteAnaliseFinanceiraAuthGuardService.canRevisar(this.status),
        };
    }

    /** Inicia a análise financeira do cliente */
    iniciar() {
        this.messageService.confirm('Deseja realmente iniciar a análise financeira deste cliente?').then((result) => {
            if (result) {
                const btn = new ButtonLoader(this.dropdownItemIniciar.nativeElement);
                btn.loading('Iniciando');
                this.clienteAnaliseFinanceiraIniciarHttpService.iniciar(this.idCliente)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        cliente => {
                            this.messageService.success('', `Análise Financeira do cliente ${this.clienteNomePipe.transform(cliente.nome, cliente.nomeFantasia, cliente.codigoIntegracaoErp)} iniciada com sucesso`);
                            this.afterIniciar.emit(cliente);
                        },
                        (error: ApiError) => this.messageService.error(error.message, error.cause, error),
                        () => btn.reset()
                    );
            }
        });
    }

    /** Cancela o inicio da análise financeira */
    cancelarIniciar() {
        this.messageService.confirm('Deseja realmente cancelar o inicio da análise financeira deste cliente?').then((result) => {
            if (result) {
                const btn = new ButtonLoader(this.dropdownItemCancelarIniciar.nativeElement);
                btn.loading('Cancelando');
                this.clienteAnaliseFinanceiraIniciarHttpService.cancelarIniciar(this.idCliente)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        cliente => {
                            this.messageService.success('', `Inicio da Análise Financeira do cliente ${this.clienteNomePipe.transform(cliente.nome, cliente.nomeFantasia, cliente.codigoIntegracaoErp)} cancelada com sucesso`);
                            this.afterCancelarIniciar.emit(cliente);
                        },
                        (error: ApiError) => this.messageService.error(error.message, error.cause, error),
                        () => btn.reset()
                    );
            }
        });
    }

    /** Cancela a conclusão da análise financeira */
    cancelarConcluir() {
        this.messageService.confirm('Deseja realmente cancelar a conclusão da análise financeira deste cliente?').then((result) => {
            if (result) {
                const btn = new ButtonLoader(this.dropdownItemCancelarConcluir.nativeElement);
                btn.loading('Cancelando');
                this.clienteAnaliseFinanceiraConcluirHttpService.cancelarConcluir(this.idCliente)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        cliente => {
                            this.messageService.success('', `Conclusão da Análise Financeira do cliente ${this.clienteNomePipe.transform(cliente.nome, cliente.nomeFantasia, cliente.codigoIntegracaoErp)} cancelada com sucesso`);
                            this.afterCancelarConcluir.emit(cliente);
                        },
                        (error: ApiError) => this.messageService.error(error.message, error.cause, error),
                        () => btn.reset()
                    );
            }
        });
    }
}
